import { render, staticRenderFns } from "./initialization.vue?vue&type=template&id=1074cb14&"
import script from "./initialization.vue?vue&type=script&lang=js&"
export * from "./initialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports